/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"wrapper_rPKyY","content":"content_1l6nb"};